import styled from "styled-components";
export const ToastBox = styled.div `
	position: fixed;
	z-index: 2;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	width: ${(props) => `${(props === null || props === void 0 ? void 0 : props.width) || 227}px`};
	height: ${(props) => `${(props === null || props === void 0 ? void 0 : props.height) || 43}px`};
	line-height: ${(props) => `${(props === null || props === void 0 ? void 0 : props.height) || 43}px`};
	background-color: rgba(0, 0, 0, 0.7);
	border-radius: 2px;
	font-size: ${(props) => `${(props === null || props === void 0 ? void 0 : props.fontSize) || 14}px`};
	text-align: center;
	color: #ffffff;
`;
